import script from "./PartnerProjectInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnerProjectInfo.vue?vue&type=script&setup=true&lang=js"

import "./PartnerProjectInfo.vue?vue&type=style&index=0&id=5ad5a224&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ad5a224"]])

export default __exports__